import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle, X } from 'lucide-react';
import { SepaMandateSetup } from './SepaMandateSetup';
import { Button } from '@/components/ui/Button';

export const SepaRequiredBanner = () => {
  const { t } = useTranslation();
  const [showSetup, setShowSetup] = useState(false);
  // Fermable pour la session en cours seulement : on propose, on n'impose pas —
  // mais la proposition revient à la prochaine connexion tant qu'il n'y a pas
  // de mandat. Pas de mémorisation durable, sinon un « plus tard » deviendrait
  // un « jamais ».
  const [fermee, setFermee] = useState(false);

  if (fermee) return null;

  return (
    <>
      <div className="border-red-200 bg-error-50 rounded-xl border border-l-4 p-4">
        <div className="flex items-start justify-between">
          <div className="flex gap-3">
            <AlertCircle className="text-error-600 mt-0.5 h-5 w-5 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="text-error-900 mb-1 font-semibold">
                {t(
                  'billing.sepa.required.title',
                  'Carte bancaire à enregistrer'
                )}
              </h3>
              <p className="text-error-700 mb-3 text-sm">
                {t(
                  'billing.sepa.required.description',
                  'Une carte bancaire est nécessaire pour le règlement de vos factures.'
                )}
              </p>
              <Button
                variant="primary"
                size="sm"
                onClick={() => setShowSetup(true)}
              >
                {t('billing.sepa.setup', 'Enregistrer une carte')}
              </Button>
            </div>
          </div>
          <button
            onClick={() => setFermee(true)}
            className="text-error-600 hover:text-error-800 transition-colors"
            aria-label={t('common.close', 'Close')}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>

      {showSetup && (
        <div className="rounded-xl border border-neutral-200 bg-white p-6">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="text-xl font-bold text-neutral-900">
              {t(
                'billing.sepa.setup.title',
                'Enregistrement de la carte bancaire'
              )}
            </h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowSetup(false)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <SepaMandateSetup />
        </div>
      )}
    </>
  );
};
